import {Directive} from '@angular/core';

@Directive({
  selector: '[appChatDialog]',
  standalone: true
})
export class ChatDialogDirective {
}
